import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { Stato } from 'src/app/shared/models/stato.model';
import { StoricoStatoDocumento } from 'src/app/shared/models/storicoStatoDocumento.model';

@Component({
  selector: 'app-tabella-storici',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <p-table [value]="storicoStatiTable()" [autoLayout]="true">
      <ng-template pTemplate="header">
        <tr>
          <th>Stato</th>
          <th>Utente</th>
          <th class="col-data">Dal</th>
          <th class="col-data">Al</th>
          <th>Note</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-storico>
        <tr [style.background-color]="storico.background">
          <td>{{ storico.stato }}</td>
          <td>{{ storico.utente }}</td>
          <td class="col-data">{{ storico.dal | dataStorico }}</td>
          <td class="col-data">{{ storico.al | dataStorico }}</td>
          <td>{{ storico.note }}</td>
        </tr>
      </ng-template>
      <ng-template pTemplate="emptymessage">
        <tr>
          <td [attr.colspan]="5">
            Nessuno storico presente.
          </td>
        </tr>
      </ng-template>
    </p-table>
  `,
  styles: [`.col-data { width: 180px; text-align: center; }`]
})
export class TabellaStoriciComponent {
  documentHistory = input<StoricoStatoDocumento[] | null>(null);
  stati = input<Stato[] | null>(null);

  public storicoStatiTable = computed<StatoTableRow[]>(() => {
    const history = this.documentHistory();
    const stati = this.stati();
    if (!history || !stati) {
      return [];
    }

    return this.createTable([...history], stati)
  });

  private createTable(history: StoricoStatoDocumento[], stati: Stato[]) {
    let previous: StatoTableRow;
    //const statiVisibili = stati.filter(s => (s.visibile || s.statoId ===21));
    const statiVisibili = stati.filter(s => s);

    return history.map((storico: StoricoStatoDocumento, i: number) => {
      const stato = stati.find(s => s.statoId === storico.toStato);
      const row: StatoTableRow = {
        background: '',
        display: storico.toStato !== 1,
        stato: stato?.nome ?? '',
        statoId: storico.toStato,
        dal: storico.timeStamp,
        note: storico.note,
        utente: storico.utente
      };

      if (storico.toStato === 0) {
        return row;
      }

      const isVisible = statiVisibili.some(s => s.statoId === storico.toStato);

      if (i > 0 && isVisible && previous && stato?.visibile) {
        previous.al = row.dal;
      }

      if (isVisible) {
        previous = row;
      } else {
        row.background = 'lightyellow';
      }

      return row;
    })
      .filter(row => row.display)
      .reverse();
  }
}

export interface StatoTableRow {
  display: boolean;
  stato: string;
  statoId: number;
  utente: string;
  dal: Date;
  al?: Date;
  note: string;
  background: string;
}
